module.exports = __webpack_public_path__ + "img/glitter_1.71f2542c.jpg";